import "./Footer.scss";

function Footer() {
  return (
    <footer className={`footer`}>
      <div className="footer_text">© 2021 Tezerion</div>
    </footer>
  );
}

export default Footer;
